import { render } from "./UserItemView.vue?vue&type=template&id=4fbd72a3"
import script from "./UserItemView.vue?vue&type=script&lang=js"
export * from "./UserItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__